<div class="ui-grid">
  @for(s of [step]; track s.name) {

  <div class="title-row" [@fadeIn]>
    <button
      mat-icon-button
      aria-label="Example icon button with a vertical three dot icon"
      (click)="onClickReturnButton()"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <!-- single-item list keyed by index to force enter/leave -->
    <h1>
      {{ s.name }}
      @if (s.subtitle) {
      <span>| {{ s.subtitle }}</span>
      }
    </h1>
  </div>
  }

  <!-- single-item list keyed by index to force enter/leave -->
  @if(filteredCardConfigs.length > 0 ) {
  <div class="card-grid">
    @for(cardConfig of filteredCardConfigs; track cardConfig.title +
    cardConfig.transitionId; let i = $index) {
    <app-card
      [config]="cardConfig"
      [hideable]="true"
      [style.view-transition-name]="cardConfig.transitionId"
      (hideCard$)="onHideCard(i)"
    ></app-card>
    }
  </div>
  }@else {
  <span class="no-impact">Aucun impact trouvé :(</span>
  }

  <div class="bottom-menu" [style.view-transition-name]="'step-bottom-menu'">
    <app-care-pathway-stepper
      [steps]="allSteps"
      [selectedIndex]="stepIndex"
      variant="in-step"
      (stepSelected)="onClickStep($event)"
    ></app-care-pathway-stepper>

    <div class="filter-menu">
      <span>Filtrer :</span>
      @for (cat of cardCategories; track $index) {
      <mat-checkbox
        class="color-{{ $index }}"
        [(ngModel)]="cardCategories[$index].active"
        (change)="onToggleFilterCheckbox()"
      >
        {{ cat.name }}
      </mat-checkbox>
      }
    </div>
  </div>
</div>
